import * as React from 'react';
import { Button, Card, CardActionArea, CardContent, CardMedia, Typography } from "@mui/material"
import { ReadMore } from '@mui/icons-material';
import { COLORS } from '../../constants/colors';

const Blog = ({ project }) => {
    return (
        <>
            <Card>
                <CardActionArea>
                    <CardMedia style={{ height: '100px' }}
                        component="img"
                        image={project.image}
                        alt={project.title}
                    />
                    <CardContent>
                        <Typography variant="body2">
                            {project.title}
                        </Typography>
                    </CardContent>
                    <Button style={{ width: '100%', backgroundColor: COLORS.secondry, color: '#fff' }}
                        component="a"
                        href={project.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        variant="contained"
                        tabIndex={-1}
                        startIcon={<ReadMore />}
                    > Read More </Button>
                </CardActionArea>
            </Card>
        </>
    )
}

export default Blog;